import {Box, Group, Stack, Title} from "@mantine/core";
import {HasEditorPrivileges} from "../../types";
import {useTranslation} from "react-i18next";
import {SettingsBox} from "./components/settings-components/SettingsBox";
import {LanguageSelectField} from "./components/settings-components/LanguageSelectField";
import {SidebarPositionSelectField} from "./components/settings-components/SidebarPositionSelectField";
import {ChatEngineSelectField} from "./components/settings-components/ChatEngineSelectField";
import {FeatureToggleGroup} from "./components/settings-components/FeatureToggleGroup";
import {useHasRole} from "../../featureFlags/featureFlags";
import {bffApi} from "./bffApi";
import {NonEditableField} from "./components/settings-components/NonEditableField";
import classes from "./SettingsPage.module.css";

export function SettingsPage() {
    const {t} = useTranslation();
    const user = bffApi.endpoints.getUser.useQuery();
    const {hasRole: hasEditorPrivileges} = useHasRole(HasEditorPrivileges);

    return (
        <Stack className={classes.page}>
            <Group className={classes.titleBox}>
                <Title order={2} className={classes.title}>
                    {t("settings.accountDetails")}
                </Title>
            </Group>
            <SettingsBox title={t("settings.accountDetails")}>
                <NonEditableField
                    label={t("settings.field.name.title")}
                    description={t("settings.field.name.description")}
                    value={user.data?.navn ?? ""}
                />
                <NonEditableField
                    label={t("settings.field.email.title")}
                    description={t("settings.field.email.description")}
                    value={user.data?.epost ?? ""}
                />
                <NonEditableField
                    label={t("settings.field.company.title")}
                    description={t("settings.field.company.description")}
                    value={user.data?.kundeNavn ?? ""}
                />
            </SettingsBox>
            <SettingsBox title={t("settings.title")}>
                <LanguageSelectField />
                {hasEditorPrivileges && (
                    <>
                        <ChatEngineSelectField />
                        <SidebarPositionSelectField />
                    </>
                )}
            </SettingsBox>
            {hasEditorPrivileges && (
                <SettingsBox
                    title="Experimental Features"
                    description="Try functionality that is under development"
                >
                    <Box className={classes.featureGroups}>
                        <FeatureToggleGroup
                            tint="green"
                            title="Content"
                            bundleKeys={["control"]}
                        />
                        <FeatureToggleGroup
                            tint="orange"
                            title="Developer"
                            bundleKeys={["internalFeatures", "debugIndicators"]}
                        />
                    </Box>
                </SettingsBox>
            )}
        </Stack>
    );
}
